import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPalette,
  faGraduationCap,
  faChartLine,
  faCouch,
  faBook,
  faCar,
  faUtensils,
  faNewspaper,
  faMusic,
  faBriefcase,
  faShirt,
  faHeartPulse,
  faSeedling,
  faGlobe,
  faSprayCan,
  faBaby,
  faPaw,
  faShoppingBag,
  faFlask,
  faUsers,
  faDumbbell,
  faPlane,
  faLaptop,
  faQuestion,
  faFilm,
} from "@fortawesome/free-solid-svg-icons";
import type { DataNode } from "antd/es/tree";

export interface CategoryItem {
  title: string;
  value: string;
  children?: CategoryItem[];
}

export const getCategoryIcon = (categoryTitle: string) => {
  const iconMap: Record<string, any> = {
    Art: faPalette,
    Education: faGraduationCap,
    Finance: faChartLine,
    Home: faCouch,
    Literature: faBook,
    Automotive: faCar,
    Food: faUtensils,
    Journalism: faNewspaper,
    Music: faMusic,
    Career: faBriefcase,
    Fashion: faShirt,
    Health: faHeartPulse,
    Lifestyle: faSeedling,
    News: faGlobe,
    Beauty: faSprayCan,
    Parenting: faBaby,
    Pets: faPaw,
    Retail: faShoppingBag,
    Science: faFlask,
    Society: faUsers,
    Sports: faDumbbell,
    Travel: faPlane,
    Tech: faLaptop,
    Other: faQuestion,
    Entertainment: faFilm,
  };

  return iconMap[categoryTitle];
};

export const transformToTreeData = (categories: CategoryItem[]): DataNode[] => {
  return categories.map((category) => {
    const children = category.children
      ? transformToTreeData(category.children)
      : undefined;

    const iconDefinition = getCategoryIcon(category.title);

    return {
      title: category.title,
      icon: iconDefinition ? (
        <FontAwesomeIcon icon={iconDefinition} className="category-icon" />
      ) : null,
      key: category.value,
      children: children && children.length > 0 ? children : undefined,
    };
  });
};

export const transformToTreeSelectData = (
  categories: CategoryItem[]
): any[] => {
  return categories.map((category) => {
    const children = category.children
      ? transformToTreeSelectData(category.children)
      : undefined;

    const iconDefinition = getCategoryIcon(category.title);

    return {
      label: (
        <>
          <FontAwesomeIcon icon={iconDefinition} className="category-icon" />{" "}
          {category.title}
        </>
      ),
      value: category.value,
      children: children && children.length > 0 ? children : undefined,
    };
  });
};
